import AuthorizationBase from "./AuthorizationBase";
import RegisterForm from "../../components/forms/authorization/RegisterForm";

const RegisterPage = () => {
    return (
        <AuthorizationBase variant="register">
            <RegisterForm />
        </AuthorizationBase>
    )
}

export default RegisterPage